import React from 'react'
import { observer } from 'mobx-react'
import { Sandwich, SandwichBun, SandwichContent } from 'components/Sandwich'
import ConversationComposer from './ConversationComposer'
import Messages from './Messages'
import styles from './ConversationView.sass'
import TypingIndicator from './TypingIndicator'
import { useElementSize } from 'hooks/element-size'
import { WelcomeAction } from './Messages/Welcome'
import JobViewModel from 'jobs/views/JobRoot/Job/JobViewModel'
import ConversationHeader from './ConversationHeader'

interface ConversationProps {
  vm: JobViewModel
  showDocumentTab(): void
  welcomeActions?: WelcomeAction[]
  banner?: React.ReactNode
  readOnly?: boolean
  scrollRef?: React.RefObject<HTMLElement | null>
}

export default observer(function ConversationView({
  vm,
  welcomeActions,
  banner,
  showDocumentTab,
  readOnly,
  scrollRef,
}: ConversationProps) {
  const contentRef = React.useRef<HTMLDivElement | null>(null)
  const size = useElementSize(contentRef)
  const small = size.width !== 0 && size.width < 800

  return (
    <Sandwich stretch className={styles.root}>
      <SandwichBun>
        <ConversationHeader vm={vm} />
        {banner}
      </SandwichBun>
      <SandwichContent ref={contentRef}>
        <Messages
          scrollRef={scrollRef}
          vm={vm.conversationVM}
          small={small}
          welcomeActions={welcomeActions}
        />
      </SandwichContent>
      {!readOnly && (
        <SandwichBun>
          <ConversationComposer
            vm={vm}
            conversationVM={vm.conversationVM}
            showDocumentTab={() => showDocumentTab()}
            small={small}
          />
          <TypingIndicator vm={vm.conversationVM} />
        </SandwichBun>
      )}
    </Sandwich>
  )
})
